export default __webpack_public_path__ + "static/media/man.f9c33030.jpg";